import { useEffect } from 'react';
import { useLocation } from 'react-router';
import sendToDataLayer from '@/lib/analytics/sendToDataLayer';
import { getUser } from '@/lib/user';

const usePageView = () => {
  const location = useLocation();

  useEffect(() => {
    const { id: userId } = getUser();

    sendToDataLayer({
      event: 'page_view',
      page_location: window.location.href,
      page_path: location.pathname,
      page_title: document.title,
      ...(userId && { userId }),
    });
  }, [location.pathname]);
};

export default usePageView;
